/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import MediaEmbed from '@components/Embeds/MediaEmbed';

/* Services */
/* Styles */
import classes from '../../styles/components/SadhguruBanner.module.css';

/**
 * Renders the Sadhguru Banner component
 *
 * @param {string} title title
 * @param {string} desc description
 * @param {string} bannerImg url
 * @param {string} videoLink url
 * @returns {ReactElement} Sadhguru Banner component
 */

const SadhguruBanner = ({ title, desc, bannerImg, videoLink }) => {
  // consoleLog('videoLink', videoLink);
  const embedObj = {
    embedUrl: videoLink,
    source: 'youtube'
  };

  return (
    // <Box className={classes.banner}>
    //   <Box className={classes["banner-wrap"]}></Box>
    //   <Box className={classes["banner-txt"]}>
    //     <Box className={classes["banner-title"]}>{title}</Box>
    //     <Box
    //       className={classes["banner-data"]}
    //       dangerouslySetInnerHTML={{ __html: desc }}
    //     ></Box>
    //   </Box>
    // <Box className={classes.videocontainer}>
    //   <iframe
    //     width="560"
    //     height="315"
    //     frameborder="0"
    //     allowfullscreen=""
    //     src={extractVideoUrl(videoLink)}
    //     id="widget2"
    //     data-gtm-yt-inspected-1_25="true"
    //     data-gtm-yt-inspected-8117874_238="true"
    //     data-gtm-yt-inspected-8117874_285="true"
    //     data-gtm-yt-inspected-8117874_299="true"
    //     data-gtm-yt-inspected-8117874_446="true"
    //   ></iframe>
    // </Box>
    // </Box>
    <Box
      float="left"
      width="100%"
      pos="relative"
      marginBottom={{
        base: '55px',
        sm: '55px',
        md: '0',
      }}
    >
      <Box
        float="left"
        w="100%"
        minHeight="500px"
        pos="relative"
        background="linear-gradient(20deg, rgb(66, 60, 52) 0%, rgb(54, 36, 19) 100%)"
        bgImage={bannerImg}
        bgSize="cover"
        bgPos="top"
        bgRepeat="no-repeat"
        clipPath={{
          base: 'polygon(0px 0px, 100% 0px, 100% 97%, 0 91%)',
          md: 'polygon(0px 0px, 100% 0px, 100% 100%, 0 90%)',
        }}
      ></Box>
      <Box
        float="left"
        w={{ base: '100%', sm: '100%', md: '50%' }}
        textAlign="left"
        paddingLeft={{
          base: '24px',
          sm: '24px',
          md: '24px',
          lg: '25px',
          xl: '85px',
        }}
        paddingTop={{ base: '0', sm: '0', md: '50px', lg: '110px' }}
        pos="absolute"
        left="0"
        right="0"
        bottom={{ md: 'unset', sm: '26px', base: '56px' }}
      >
        <Text
          float="left"
          w="100%"
          textAlign="left"
          fontFamily="FedraSerifAStdBook,sans-serif"
          fontSize={{
            base: '45px',
            md: '45px',
            lg: '72px',
          }}
          color={'albescentWhite'}
          lineHeight={'inherit'}
          paddingRight={{ base: '0', md: '80px' }}
        >
          {title}
        </Text>
        <Text
          float="left"
          w={{ base: '95%', sm: '100%', md: '70%' }}
          textAlign="left"
          fontFamily="FedraSansStd-book,sans-serif"
          fontSize={{
            base: '16px',
            xl: '18px',
          }}
          as="div"
          color={'#d6b99b'}
          paddingTop={{ base: '10px', md: '30px' }}
          lineHeight={1.5}
        >
          {parser(desc)}
        </Text>
      </Box>
      <Box
        top={{ base: '35px', md: '65px' }}
        position="absolute"
        right={{ base: '0', sm: '0', md: '25px', lg: '80px' }}
        width={{ base: '100%', sm: '100%', md: '55%', lg: '50%' }}
        className={classes.videocontainer}
      >
        <Box
          w={{ base: '100%', sm: '100%', md: '100%', lg: '560px' }}
          float="right"
          height={{ base: '230px', sm: '230px', md: '230px', lg: '315px' }}
        >
          {/* <iframe
            frameBorder="0"
            allowFullScreen
            src={extractVideoUrl(videoLink)}
            id="widget2"
            data-gtm-yt-inspected-1_25="true"
            data-gtm-yt-inspected-8117874_238="true"
            data-gtm-yt-inspected-8117874_285="true"
            data-gtm-yt-inspected-8117874_299="true"
            data-gtm-yt-inspected-8117874_446="true"
          ></iframe> */}

          <MediaEmbed sectionContent={embedObj} margin="0" />
        </Box>
      </Box>
    </Box>
  );
};

export default SadhguruBanner;
